/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { ComplaintDto } from "./complaintDto";
import { TicketState } from "./ticketState";

export class TicketDto {
	public id: number = 0;
	public state: TicketState = TicketState.Legacy;
	public orderId: string = "";
	public customerId: string = "";
	public fertigerId: number = 0;
	public customerName: string = "";
	public customerPhone: string = "";
	public customerEmail: string = "";
	public useAlternativeContactInfo: boolean = false;
	public alternativePhone: string = "";
	public alternativeEmail: string = "";
	public manufacturerName: string = "";
	public createdAt: Date = new Date();
	public complains: ComplaintDto[] = new Array<ComplaintDto>();
	public newDueDate: Date = new Date();
	public customerRepairCollectionDate: Date = new Date();
}
